import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogActions, Button } from "@material-ui/core";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import {
  getDataWithQueryString,
  postData,
} from "../../../../../../api/componentAPIs";
import appConstants from "../../../../../../appConstants";
import { trackEvent } from "../../../../../common/AppInsightsEventTracking";
import { withSnackbar } from "notistack";
import Events from "../../../../../../utilities/EventEmitter";
import { Form, ProDetails } from "./components";
import Error from "../common/Error";
const LoaderDialog = React.lazy(() =>
  import("../../../../../header/dispatchHeader/DispatchLoader")
);
import { TAIL_LOADING_ZONE } from "./constants";

const dialogStyles = (theme) => ({
  root: {
    margin: 0,
    marginBottom: 0,
    padding: 16,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 16,
    color: theme.iconColor,
  },
  actionButton: { minWidth: "136px" },
});
const DialogTitle = withStyles(dialogStyles)((props) => {
  const { children, classes, onClose, handleClose, ...other } = props;
  return (
    <div>
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        {children}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
    </div>
  );
});

class AddProDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputProNumber: {
        inputValue: "",
        error: null,
      },
      loadingZone: TAIL_LOADING_ZONE,
      showProDetails: false,
      addProInProgress: false,
      isGetProDetailsInProgress: false,
      addProErrorMessage: "",
    };
    this.timer = null;
    this.container = React.createRef();
  }

  componentDidMount() {
    Events.on("proAdded", this.checkAddProEventStatus);
  }

  componentWillUnmount() {
    Events.off("proAdded", this.checkAddProEventStatus);
  }

  handleChange = (name) => (value) => {
    this.setState({
      [name]: {
        inputValue: value,
        error: this.getFieldError(name, value),
      },
    });
  };

  handleLoadingZone = (_event, loadingZone) => {
    if (!loadingZone) return;
    this.setState({ loadingZone });
  };

  submitProNumber = () => {
    const { userData } = this.props;
    const proNumberError = this.getFieldError(
      "inputProNumber",
      this.state.inputProNumber.inputValue
    );
    if (proNumberError) {
      this.updateProError(proNumberError);
      return;
    }
    this.setState({
      isGetProDetailsInProgress: true,
    });
    getDataWithQueryString(
      "GetProDetails",
      `terminalCode=${userData.userProfile.terminal.code}&proId=${this.state.inputProNumber.inputValue}`
    ).then(
      (response) => {
        if (Math.trunc(response.status / 100) === 2) {
          this.setState({
            showProDetails: true,
            shipmentData: response.data,
            isGetProDetailsInProgress: false,
          });
        } else {
          const error = response?.response?.data?.error?.message;
          this.updateProError(error);
        }
      },
      () => {
        this.updateProError("Error fetching pro details");
      }
    );
  };

  updateProError = (proError) => {
    this.setState((prevState) => ({
      inputProNumber: {
        ...prevState.inputProNumber,
        error: proError,
      },
      isGetProDetailsInProgress: false,
    }));
  };

  handleError = (errorMsg) => {
    this.props.enqueueSnackbar(errorMsg, {
      variant: "error",
    });
  };

  getFieldError = (field, value) => {
    switch (field) {
      case "inputProNumber":
        return value ? null : "* Required";
      default:
        return null;
    }
  };

  onAddProProgressTimeOut = () => {
    this.timer = setTimeout(() => {
      this.setState({ addProInProgress: false });
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  checkAddProEventStatus = (data) => {
    const { success, proIds } = data;
    if (success) {
      this.props.enqueueSnackbar(
        `Pro #${proIds.join(",")} added successfully`,
        {
          variant: "success",
        }
      );
      this.props.handleClose();
    } else {
      this.handleError(`Failed to add pro #${proIds.join(",")}`);
      this.setState({
        addProInProgress: false,
        addProErrorMessage: data?.message,
      });
    }
    clearTimeout(this.timer);
  };

  addPro = () => {
    const { userData, routeData } = this.props;
    const requestObj = {
      terminalCode: userData.userProfile.terminal.code,
      proId: this.state.inputProNumber.inputValue,
      driverId: routeData.driverId,
      routeId: routeData.routeId,
      loadingZone: this.state.loadingZone,
    };
    this.setState(
      {
        addProInProgress: true,
      },
      this.onAddProProgressTimeOut
    );
    trackEvent("Add_Pro", this.props.userProfile, {
      event: "Add_Pro",
      eventData: requestObj,
    });
    postData("AddPro", requestObj).then(
      (response) => {
        if (response.status < 200 && response.status > 200) {
          this.handleError(`Failed to add pro #${requestObj.proId}`);
          this.setState({
            addProInProgress: false,
          });
        }
      },
      () => {
        this.handleError(`Failed to add pro #${requestObj.proId}`);
        this.setState({
          addProInProgress: false,
        });
      }
    );
  };

  render() {
    const { classes, open, handleClose } = this.props;
    const { theme } = this.props.userData.userProfile || {};
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${
            theme === "dark" ? "darkTheme" : "lightTheme"
          } `}
        >
          <DialogTitle
            handleClose={handleClose}
            id="customized-dialog-title"
            className={classes.divider}
          >
            <div>
              <span className={classes.dialogTitle}>Add Pro</span>
            </div>
          </DialogTitle>
          <DialogContent className="customScroll">
            {!this.state.showProDetails && (
              <Form
                handleChange={this.handleChange}
                proData={this.state.inputProNumber}
                handleSubmit={this.submitProNumber}
                isGetProDetailsInProgress={this.state.isGetProDetailsInProgress}
              />
            )}
            {this.state.showProDetails && (
              <>
                <ProDetails
                  shipmentData={this.state.shipmentData}
                  handleChange={this.handleLoadingZone}
                  loadingZone={this.state.loadingZone}
                />
                {this.state.addProErrorMessage && (
                  <Error
                    message={this.state.addProErrorMessage}
                    label="Add Pro Error"
                  />
                )}
              </>
            )}
          </DialogContent>
          {this.state.showProDetails && (
            <div className={classes.dialogFooter}>
              <DialogActions>
                <Button
                  autoFocus
                  onClick={handleClose}
                  color="primary"
                  variant="outlined"
                  className={classes.actionButton}
                >
                  Close
                </Button>
              </DialogActions>
              <DialogActions>
                <Button
                  autoFocus
                  color="primary"
                  variant="contained"
                  className={classes.actionButton}
                  onClick={this.addPro}
                >
                  Add Pro
                </Button>
              </DialogActions>
            </div>
          )}
        </Dialog>
        {this.state.addProInProgress && (
          <LoaderDialog
            container={this.container.current}
            eventName="Add Pro"
          />
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar
)(AddProDialog);
